module.exports = __webpack_public_path__ + "img/wap_xen2.e3cf3cca.jpg";